import './bootstrap';
import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Gate from '../../../public/js/gate';
//import vSelect from 'vue-select'
import VTooltip from 'v-tooltip';
import ToggleButton from 'vue-js-toggle-button';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue2Filters from 'vue2-filters';
import PortalVue from 'portal-vue'
import VuePaginate from 'vue-paginate';
import VueObserveVisibility from 'vue-observe-visibility';

import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import Charts from 'fusioncharts/fusioncharts.charts';
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import Widgets from "fusioncharts/fusioncharts.widgets";

import ModuleAccessOverlayPlugin from './plugins/ModuleAccessOverlay';
import InfoIcon from './components/icons/InfoIcon.vue';
import DashboardV1 from './components/theme/v1/dashboard/DashboardV1.vue';
import BrokerDashboard from './components/theme/v1/broker/BrokerDashboard.vue';

// Import shared components that need to be available in both themes
import ThemeSelector from './components/theme/ThemeSelector.vue';
import ThemeToggle from './components/theme/ThemeToggle.vue';
import PublicViewPage from './components/theme/v1/public/PublicViewPage.vue';
import CalculatorToolboxLanding from './components/theme/v1/public/CalculatorToolboxLanding.vue';
import LeaseFileUploadPage from './components/theme/v1/public/LeaseFileUploadPage.vue';
import PublicLeaseAuditHeader from './components/theme/v1/public/PublicLeaseAuditHeader.vue';
import DockBottleneckCalculator from './components/theme/v1/public/DockBottleneckCalculator.vue';
import RackOptimizationCalculator from './components/theme/v1/public/RackOptimizationCalculator.vue';
import HvacCalculator from './components/theme/v1/public/HvacCalculator.vue';

FusionCharts.options.license({ key: 'jxD3pocC5E3D4B1E1H1C2B3E6C-11zpnH-8G2C11rfwB4F1D4G2B1A2C2D6C1D1C4G1H4G2A1A4fyF-10E2F4D1F-7B3D5D1nmdG4A9A32bfuC6B5G4fB-7zA9C5A5D7E1E5E1H4A1C3A4B-16uwG2F4FF1ycrC7A3B4crC3UA7A5nhyD3G2F2A10B8D7D5D2C4G4G2G3A8A2a==', creditLabel: false });

// import HighchartsVue from 'highcharts-vue';
// import Highcharts from 'highcharts';
// import HighchartsMore from 'highcharts/highcharts-more';
// import SolidGauge from 'highcharts/modules/solid-gauge';
// import BulletChart from 'highcharts/modules/bullet';

// HighchartsMore(Highcharts);
// SolidGauge(Highcharts);
// BulletChart(Highcharts);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VTooltip);
Vue.use(ToggleButton);
Vue.use(Notifications);
Vue.use(VModal);
Vue.use(ModuleAccessOverlayPlugin);
Vue.use(VueSweetalert2);
Vue.use(Vue2Filters);
Vue.use(PortalVue);
Vue.use(VuePaginate);
Vue.use(VueObserveVisibility);
Vue.use(VueFusionCharts, FusionCharts, FusionTheme, Charts, PowerCharts, Widgets);
// Vue.use(HighchartsVue, { Highcharts });
Vue.use(Toast, {
    position: 'bottom-right',
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
});

/**
 * Component Registration Strategy:
 * 
 * 1. Register shared components (available in both themes)
 * 2. Register old/original components (excluding theme folder)
 * 3. Conditionally register v1 theme components based on user preference
 */

// Register shared components that work in both themes
Vue.component('ThemeSelector', ThemeSelector);
Vue.component('ThemeToggle', ThemeToggle);
Vue.component('InfoIcon', InfoIcon);
Vue.component('DashboardV1', DashboardV1);
Vue.component('BrokerDashboard', BrokerDashboard);
Vue.component('PublicViewPage', PublicViewPage);
Vue.component('CalculatorToolboxLanding', CalculatorToolboxLanding);
Vue.component('LeaseFileUploadPage', LeaseFileUploadPage);
Vue.component('PublicLeaseAuditHeader', PublicLeaseAuditHeader);
Vue.component('DockBottleneckCalculator', DockBottleneckCalculator);
Vue.component('RackOptimizationCalculator', RackOptimizationCalculator);
Vue.component('HvacCalculator', HvacCalculator);

// Get theme preference early
const themeVersion = localStorage.getItem('reopt_theme_version') || 'v1';

// Register original/old components (excluding theme folder to avoid conflicts)
const sharedComponentNames = ['ThemeSelector', 'ThemeToggle', 'InfoIcon', 'DashboardV1', 'PublicViewPage', 'CalculatorToolboxLanding', 'LeaseFileUploadPage', 'PublicLeaseAuditHeader', 'DockBottleneckCalculator', 'RackOptimizationCalculator', 'HvacCalculator'];
const originalModules = import.meta.glob('./components/**/*.{vue,js}', { eager: true });
Object.entries(originalModules)
    .filter(([key]) => {
        // Exclude v1 theme components and shared theme components
        return !key.includes('/theme/v1/') &&
            !key.includes('/theme/ThemeSelector.vue') &&
            !key.includes('/theme/ThemeToggle.vue');
    })
    .forEach(([key, module]) => {
        const componentName = key.split('/').pop().split('.')[0];
        // Skip if already registered as shared component
        if (!sharedComponentNames.includes(componentName) && module.default) {
            Vue.component(componentName, module.default);
        }
    });

// Conditionally register v1 theme components only when v1 theme is active
if (themeVersion === 'v1') {
    const v1Modules = import.meta.glob('./components/theme/v1/**/*.vue', { eager: true });
    Object.entries(v1Modules).forEach(([key, module]) => {
        const componentName = key.split('/').pop().split('.')[0];
        // Register with original name to override old components
        if (module.default) {
            Vue.component(componentName, module.default);
        }
    });
}

// custom vue mixins
import './vue-mixins.js';

// custom vue filters
import './vue-filters.js';

// vue stores
import store from './vue-stores.js';

// security gate
Vue.prototype.$gate = new Gate(window.user);

Vue.prototype.$eventHub = new Vue(); // Global event bus

// prototypes (side-effect only — modifies Number.prototype and Vue.prototype)
import './prototypes.js';


// Sentry error monitoring (all non-local environments)
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/vue';

const sentryEnv = import.meta.env.VITE_APP_ENV || 'local';
const sentryDsn = import.meta.env.VITE_SENTRY_DSN_PUBLIC;

if (sentryDsn && sentryEnv !== 'local') {
    Sentry.init({
        Vue,
        dsn: sentryDsn,
        environment: sentryEnv, // 'production', 'staging', 'dev', etc.
        integrations: [new BrowserTracing()],
        // Lower sample rate in production to reduce volume; capture all in staging
        tracesSampleRate: sentryEnv === 'production' ? 0.2 : 1.0,
        logErrors: true, // still log to console in all envs
    });
}

Vue.config.errorHandler = function (err, vm, info) {
    console.error(err);
    if (sentryDsn && sentryEnv !== 'local') {
        Sentry.captureException(err);
    }
};

Vue.config.warnHandler = function (msg, vm, trace) {
    console.warn('[Vue warn]: ' + msg + trace);
};

// root vue instance
new Vue({
    el: '#app',
    store: store,
    components: {
        InfoIcon,
        DashboardV1
    },
    mounted() {
        let baseCurrency = localStorage.getItem(`reopt_baseCurrency`) || 'USD';
        let selectedCurrency = localStorage.getItem(`reopt_selectedCurrency`) || 'USD';

        if (baseCurrency != selectedCurrency) {
            this.$eventHub.$emit('convert-currency', {
                from: baseCurrency,
                to: selectedCurrency
            });
        }
    }
});

